<section class="cta-redesign">

    <div class="container-redesign">

        <div class="cta-redesign__card">

            <h2 class="cta-redesign__title">
                {{ title }}
            </h2>

            <p class="cta-redesign__description">
                {{ description }}
            </p>

            <div class="cta-redesign__actions">

    <a
        routerLink="/contact-redesign"
        class="cta-banner__button cta-banner__button--primary">

        <span>TALK TO OUR TEAM</span>

        <img
            src="/assets/img/redesign/flecha.svg"
            alt=""
            class="cta-banner__button-icon">

    </a>

    <a
        href="https://system.demo.myaltheasoft.com"
        class="cta-banner__button cta-banner__button--secondary">

        <span>PLATFORM DEMO</span>

    </a>

</div>

        </div>

    </div>

</section>